import {
    BOOKING_ATTEMPT_ERROR,
    BOOKING_ATTEMPT_RESET,
    BOOKING_ATTEMPT_SAVE_START,
    BOOKING_ATTEMPT_SAVE_SUCCESS,
    BookingAttemptAction
} from 'actions/bookingAttempts/BookingAttemptsActionsTypes';
import {
    BookingAttemptsState,
    BookingAttemptsStatus
} from 'reducers/bookingAttempts/BookingAttemptsState';
import { Reducer } from 'redux';

const initialState: BookingAttemptsState = {
    loading: false,
    status: BookingAttemptsStatus.Initial
};

export const bookingAttemptsReducer: Reducer<BookingAttemptsState, BookingAttemptAction> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case BOOKING_ATTEMPT_RESET:
            return {
                ...initialState
            };
        case BOOKING_ATTEMPT_ERROR:
            return {
                ...state,
                status: BookingAttemptsStatus.Error
            };
        case BOOKING_ATTEMPT_SAVE_START:
            return {
                ...state,
                bookingAttempt: undefined,
                status: BookingAttemptsStatus.SaveStart
            };
        case BOOKING_ATTEMPT_SAVE_SUCCESS:
            return {
                ...state,
                status: BookingAttemptsStatus.SaveSuccess,
                bookingAttempt: action.payload.bookingAttempt
            };
        default:
            return state;
    }
};
